import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { AuthClientService } from 'src/app/@Services/@client-website/authclient.service';

@Injectable()
export class AuthWebsiteInterceptor implements HttpInterceptor {
  constructor(private _authClientService: AuthClientService,) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
    console.log('_____ interceptor in client website _____');
    
    const logindata: any = localStorage.getItem('websiteUser');
    const websiteUser = JSON.parse(logindata);
    
    let cookie: any = {};
    document.cookie.split(';').forEach((el) => {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });

    if (!websiteUser) {
      return next.handle(request);
    } else {
      const modifyReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${websiteUser._token}`,
        },
      });
      return next.handle(modifyReq).pipe( 
        tap({
          error: (err) => {
            console.log(err,' <--Error');
            if(err.status == 401){ 
              this._authClientService.setNewAccess_token(websiteUser._retoken);
            };
          },
        })
      );;
    }
  }
}


// import { Injectable } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpResponse,
// } from '@angular/common/http';
// import { Observable, throwError } from 'rxjs';
// import { catchError, map, tap } from 'rxjs/operators';
// import { AuthClientService } from 'src/app/@Services/@client-website/authclient.service';
// import { environment } from 'src/environments/environment.dev';
// import { prepareDataForEncryption } from './auth.utils';

// const enkey = environment.enkey;

// @Injectable()
// export class AuthWebsiteInterceptor implements HttpInterceptor {
//   constructor(private _authClientService: AuthClientService) {}

//   private rc4(key: any, data: Uint8Array): Uint8Array {
//     let S = Array.from({ length: 256 }, (_, i) => i);
//     let j = 0;
//     let out = [];

//     key = new TextEncoder().encode(key);
//     for (let i = 0; i < 256; i++) {
//       j = (j + S[i] + key[i % key.length]) % 256;
//       [S[i], S[j]] = [S[j], S[i]];
//     }

//     let i = 0;
//     j = 0;
//     for (let char of data) {
//       i = (i + 1) % 256;
//       j = (j + S[i]) % 256;
//       [S[i], S[j]] = [S[j], S[i]];
//       let k = S[(S[i] + S[j]) % 256];
//       out.push(char ^ k);
//     }

//     return new Uint8Array(out);
//   }

//   private base64Encode(bytes: Uint8Array): string {
//     return btoa(String.fromCharCode(...bytes));
//   }

//   private base64Decode(str: string): Uint8Array {
//     const binaryString = atob(str);
//     return new Uint8Array([...binaryString].map(char => char.charCodeAt(0)));
//   }

//   intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
//     console.log('_____ interceptor in client website _____');

//     const logindata: any = localStorage.getItem('websiteUser');
//     const websiteUser = logindata ? JSON.parse(logindata) : null;

//     let modifiedRequest = request;

//     if (websiteUser) {
//       modifiedRequest = modifiedRequest.clone({
//         setHeaders: {
//           Authorization: `Bearer ${websiteUser._token}`,
//         },
//       });
//     }

//     if (['POST', 'PUT', 'PATCH'].includes(request.method) && request.body) {
//       let bodyToEncrypt = prepareDataForEncryption(request.body);
//       const bodyBytes = new TextEncoder().encode(JSON.stringify(bodyToEncrypt));
//       const encryptedBytes = this.rc4(enkey, bodyBytes);
//       const encryptedBody = this.base64Encode(encryptedBytes);

//       modifiedRequest = modifiedRequest.clone({
//         body: { encrypted_body: encryptedBody },
//       });
//     }

//     return next.handle(modifiedRequest).pipe(
//       map((event: HttpEvent<any>) => {
//         if (event instanceof HttpResponse && event.body?.data) {
//           const decryptedBytes = this.base64Decode(event.body.data);
//           const decryptedResponse = this.rc4(enkey, decryptedBytes);
//           try {
//             const decryptedJson = new TextDecoder().decode(decryptedResponse);
//             return event.clone({ body: { data: JSON.parse(decryptedJson) } });
//           } catch (e) {
//             console.error('Error parsing decrypted response:', e);
//             return event;
//           }
//         }
//         return event;
//       }),
//       tap({
//         error: (err) => {
//           console.log(err, ' <--Error');
//           if (err.status === 401 && websiteUser?._retoken) {
//             this._authClientService.setNewAccess_token(websiteUser._retoken);
//           }
//         },
//       }),
//       catchError((error) => throwError(() => error))
//     );
//   }
// }
